// extracted by mini-css-extract-plugin
module.exports = {"notificationIcon":"CallWaiterButton_notificationIcon__klk0T","notification":"CallWaiterButton_notification__3wnoK"};